// utils
import axiosInstance from '../../utils/axios';

const getUserData = async (userId) => {
  try {
    const response = await axiosInstance({
      method: 'get',
      url: `/users/${userId}`,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getUserData };
